export { default as default } from './NoResults';
